import { useTranslation } from '@chr/online-shared-ui-localizations';
import { StepLabel } from "@mui/material";
import { StatusBarIcon } from "../../common/components/stepper/StatusBarIcon";
import { Step } from "../../common/components/stepper/Step";
import { Stepper } from "../../common/components/stepper/Stepper";
import { Status } from '../../common/apis/dtos';

declare interface StatusBarProps {
  status: Status;
  isMobileScreen: boolean;
}

export const getActiveStep = (status: Status) => {
  let activeStep:number;
  
  switch (status) {
    case Status.None:
    case Status.Ordered:
      activeStep = 0;
      break;
    case Status.Booked:
      activeStep = 1;
      break;
    case Status.InTransit:
      activeStep = 2;
      break;
    case Status.Delivered:
      activeStep = 3;
      break;
  }

  return activeStep;
}

export const StatusBar = ({status, isMobileScreen}: StatusBarProps) => {
  const translate = useTranslation();

  return (
    <Stepper
      orientation={isMobileScreen ? 'vertical' : 'horizontal'}
      activeStep={getActiveStep(status)}
      alternativeLabel
      aria-label={translate('Shipment Status')}
      data-testid="shipment-status"
    >
      <Step key="Ordered" stepIds="shipmentStatus">
        <StepLabel StepIconComponent={StatusBarIcon}>{translate('Ordered')}</StepLabel>
      </Step>
      <Step key="Booked" stepIds="shipmentStatus">
        <StepLabel StepIconComponent={StatusBarIcon}>{translate('Booked')}</StepLabel>
      </Step>
      <Step key="InTransit" stepIds="shipmentStatus">
        <StepLabel StepIconComponent={StatusBarIcon}>{translate('In Transit')}</StepLabel>
      </Step>
      <Step key="Delivered" stepIds="shipmentStatus">
        <StepLabel StepIconComponent={StatusBarIcon}>{translate('Delivered')}</StepLabel>
      </Step>
    </Stepper>
  );
};

export default StatusBar;
